
import classNames from 'classnames';
import { connectToStores } from 'fluxible-addons-react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { learnMoreAboutPage } from '../actions/LearnMoreActionCreators';
import LearnMoreStore from '../stores/LearnMoreStore';

@connectToStores([LearnMoreStore], (context) => {
  const learnMoreStore = context.getStore(LearnMoreStore);
  return {
    helpVideo: learnMoreStore.getHelpVideo(),
    loading: learnMoreStore.isLoading(),
    error: learnMoreStore.hasError()
  };
})
class LearnMore extends React.Component {

  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string
    }),
    helpVideo: ImmutablePropTypes.mapContains({
      name: PropTypes.string.isRequired,
      helpVideoUrl: PropTypes.string.isRequired
    }),
    loading: PropTypes.bool,
    error: PropTypes.string
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { showModal: false };
  }

  componentDidMount() {
    const { location: { pathname: pagePath } } = this.props;
    this.context.executeAction(learnMoreAboutPage, pagePath);
  }

  componentDidUpdate(prevProps) {
    const prevPagePath = prevProps.location.pathname;
    const pagePath = this.props.location.pathname;
    if (prevPagePath !== pagePath) {
      this.context.executeAction(learnMoreAboutPage, pagePath);
    }
  }

  toggle = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  render() {
    const titleSuffix = this.props.helpVideo ?
      ` - ${this.props.helpVideo.get('name')}` :
      '';
    const helpVideoUrl = this.props.helpVideo ?
      this.props.helpVideo.get('helpVideoUrl') :
      '//0.0.0.0';
    return <div>
      <a
        className={`btn btn-link learn-more ${classNames({'invisible': !!this.props.error})}`}
        href='#'
        onClick={this.toggle}
      >
        Help&nbsp;
        <FontAwesome name='video-camera'/>
      </a>
      <Modal isOpen={this.state.showModal} toggle={this.toggle} className='learn-more-modal'>
        <ModalHeader toggle={this.toggle}>Help{titleSuffix}</ModalHeader>
        <ModalBody className={classNames({'loading': this.props.loading})}>
          <div className={classNames({'invisible': this.props.loading})}>
            <iframe width='560' height='315' src={helpVideoUrl} frameBorder='0' allowFullScreen></iframe>
          </div>
        </ModalBody>
      </Modal>
    </div>;
  }

}

export default LearnMore;



// WEBPACK FOOTER //
// ./src/components/LearnMore.js